// services/connection.service.ts
import { Injectable } from '@angular/core';
import { BehaviorSubject } from 'rxjs';

@Injectable({
  providedIn: 'root', // This makes the service available application-wide
})
export class ConnectionService {
  private onlineSubject = new BehaviorSubject<boolean>(true);
  online$ = this.onlineSubject.asObservable();

  setOnlineStatus(status: boolean) {
    this.onlineSubject.next(status);
  }
}
